import React, { Component } from 'react';
import {isAuthorized, authorizePublishing} from "nft/sign.js"
import {lstorage} from 'utils/lstorage.js';
import Colors from 'components/Colors.js';
import ethereum from 'decentralized/ethereum.js';
import PasswordModal from 'components/modals/PasswordModal.js';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import ConditionedComponent from 'components/ConditionedComponent.js';
import ConditionedCheckmark from 'components/ConditionedCheckmark.js';
import {setIsManagingGuilds, setSelectedGuild, setShowLogin, setSigningUp} from 'actions/index.js';
import { connect } from "react-redux";
import accounts from 'accounts/Accounts.js';
import '../../Guilds.scss';

const colors = new Colors();

class GuildsMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthorized: false,
            toggled: false,
            guilds: [],
        };

        ethereum.store = this.props.store;
        accounts.setStore(this.props.store);
        accounts.setEthereum(ethereum);
        accounts.checkLogin();

        this.getGuilds();
        this.getUserName();
    }

    componentDidMount() {
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props.userToken !== nextProps.userToken) {
            this.getGuilds();
            this.getUserName();
        }
        if (this.state.toggled !== nextState.toggled) {
            {/*isAuthorized().then(
               x => this.setState({isAuthorized: x}));*/}
        }
        return true;
    }

    async getUserName() {
        let userName = await accounts.getUserName();
        this.setState({userName: userName});
    }

    async getGuilds() {
        let allGuilds = await ethereum.guilds.getGuildsForUser();
        let selectedGuild = lstorage.getItem("selectedGuild");
        if (selectedGuild) {
            try {
                selectedGuild = JSON.parse(selectedGuild);
                if (selectedGuild && allGuilds.some(g => g.guildId === selectedGuild.guildId)) {
                    // the locally stored guild is indeed a guild they are a
                    // part of
                    this.props.setSelectedGuild(
                        allGuilds.find(g => g.guildId === selectedGuild.guildId));
                }
            } catch (e) {
                
            }
        }
        this.setState({
            guilds: allGuilds.filter(x => !x.name.includes(",")),
        });
        //if (allGuilds.length > 0) {
        //    this.onClickGuild(allGuilds[0]);
       // }
    }

    onClickLogIn() {
        this.props.setSigningUp(false);
        this.props.setShowLogin(true);
    }

    onClickSignUp() {
        this.props.setSigningUp(true);
        this.props.setShowLogin(true);
    }

    onClickLogout() {
        accounts.logout();
    }

    onClickGuild(guild) {
        if (guild !== undefined) {
            ethereum.crypto.getPassword();
        }
        this.props.setSelectedGuild(guild);
        lstorage.setItem("selectedGuild", JSON.stringify(guild));
    }

    toggle() {
        this.setState({
            toggled: !this.state.toggled
        });
    }

    getSelectedGuild() {
        return this.props.selectedGuild ?
            this.props.selectedGuild.name :
            this.state.userName;
    }

    onClickConnect() {
        isAuthorized().then(
            x => {
                if (!x) {
                    authorizePublishing();
                }
                this.setState({
                    isAuthorized: x
                });
            });
    }

    goToGuildsPage() {
        //
        // window.location.href = '/guilds';
    }

    render() {
        return (
            <div className="guilds-menu">
              <PasswordModal crypto={ethereum.crypto} show={true}/>
                <ButtonDropdown
                  className="view-dropdown guilds-dropdown"
                  show={this.state.toggled ? "true" : "false"}
                  isOpen={this.state.toggled}
                  toggle={() => this.toggle()}>
                    {accounts.isLoggedIn() ?
                      <DropdownToggle size="sm" caret color="primary">
                            <div style={this.props.selectedGuild && {backgroundColor: colors.getColorForHash(this.getSelectedGuild())}} className="not-recording-dot"/>
                        <span className="guild-name">{this.getSelectedGuild()}</span>
                      </DropdownToggle>
                      : 
                      <DropdownToggle size="sm" caret color="primary">
                            <div className="not-recording-dot logged-out"/>
                                Log In
                      </DropdownToggle>
                      }
                  <DropdownMenu>
                    <ConditionedComponent condition={!accounts.isLoggedIn()}>
                     <DropdownItem
                      key=""
                       onClick={() => this.onClickLogIn()}
                      size="sm">
                       Log In
                    </DropdownItem>
                     <DropdownItem
                      key="public"
                       onClick={() => this.onClickSignUp()}
                      size="sm">
                       Sign Up
                    </DropdownItem>
                      
                    </ConditionedComponent>
                    <ConditionedComponent condition={accounts.isLoggedIn()}>
                      <div onClick={() => this.props.setIsManagingGuilds(true)} className="guilds-mgmt-btn">
                        Manage Groups
                      </div>

                      <DropdownItem
                      key="public"
                        className="connect-wallet-option"
                      size="sm">
                        {this.state.isAuthorized ?
                         <div className="guild-dropdown-option connected-btn">
                           {trim(this.state.isAuthorized)} 
                         </div> : <div
                                    onClick={() => this.onClickConnect(undefined)}
                                    className="guild-dropdown-option connect-wallet-btn">
                        <div>Connect Wallet</div>
                                  </div>}
                      </DropdownItem>
                      <DropdownItem
                      key="public"
                      onClick={() => this.onClickGuild(undefined)}
                      size="sm">
                      <div className="guild-dropdown-option">
                        <div>Everything</div>
                      <ConditionedCheckmark
                        className="guilds-checkmark"
                        condition={this.props.selectedGuild === undefined}/>
                      </div>
                    </DropdownItem>
                      <div className="section-header">
                        Groups
                      </div>
                    {this.state.guilds.map(
                        guild =>
                            <DropdownItem
                                  key={guild.name}
                                  onClick={() => this.onClickGuild(guild)}
                                  size="sm">
                                  <div className="guild-dropdown-option">
                                    <div style={{backgroundColor: colors.getColorForHash(guild.name)}} className="dot"></div>
                                    <div>{guild.name}</div>
                                            <ConditionedCheckmark className="guilds-checkmark" condition={this.props.selectedGuild === guild}/>
                                  </div>
                            </DropdownItem>)}
                      <div className="user-name-item">
                        <div className="not-recording-dot"/> <span className="guild-user-name">{this.state.userName}</span> 
                      </div>
                 <div
                   onClick={() => this.onClickLogout()}
                   className="logout-btn"> Log out </div>
                    
                    </ConditionedComponent>
                  </DropdownMenu>
                </ButtonDropdown>
            </div>
        );
   }
}
const mapDispatchToProps = dispatch => {
    return {
        setSelectedGuild: guild => dispatch(setSelectedGuild(guild)),
        setShowLogin: show=> dispatch(setShowLogin(show)),
        setSigningUp: show=> dispatch(setSigningUp(show)),
        setIsManagingGuilds: show=> dispatch(setIsManagingGuilds(show))
    };
};
 
const mapStateToProps = state => {
    return {
        selectedGuild: state.guilds.selectedGuild,
        userToken: state.sequencer.userToken,
    };
}

const trim = (x) => {
    if (x.length > 12) {
        return x.slice(0, 12) + '...';
    }
    return x;
};
 
export default connect(mapStateToProps, mapDispatchToProps)(GuildsMenu);
